import { defineComponent as _defineComponent } from 'vue'
import BriefcaseMassAddDialog from "@/components/BriefcaseMassAddDialog.vue";
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import ExportButton from "@/components/buttons/ExportButton.vue";
import ProfileCard from "@/components/ProfileCard.vue";
import ProfileListItem from "@/components/ProfileListItem.vue";
import SearchChipsContainer from "@/components/search/SearchChipsContainer.vue";
import { ApiService, LogService, SearchService } from "@/services";
import { useSearchStore } from "@/pinia/search";
import {
  ProfileView,
  SearchOrder,
  SearchQueryUpdatePayload,
  VignetteEndpoints,
} from "@/types";
import { useSessionStore } from "@/pinia/session";
import { computed, onBeforeMount, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { useAppStore } from "@/pinia/app";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResults',
  setup(__props) {

const router = useRouter();

const isMassAddDialogOpen = ref(false);

const searchStore = useSearchStore();
const searchItems = computed(
  () => searchStore.getVignetteSearchCurrentPageItems
);
const isLoading = computed(() => searchStore.isSearchLoading);
const isPaginated = computed(() => searchStore.getLastSearchQueryPageCount > 1);
const currentPage = computed(() => searchStore.lastSearchQuery.page);
const pageSize = computed(() => searchStore.getLastSearchQueryPageSize);
const pageCount = computed(() => searchStore.getLastSearchQueryPageCount);
const hitCount = computed(() => searchStore.getLastSearchQueryHitsCount);
const order = computed(() => searchStore.getLastSearchQueryOrder);
const isListViewMode = computed(
  () => searchStore.getLastSearchQueryView === ProfileView.LIST
);
const searchQuery = computed(() => searchStore.lastSearchQuery);

const appStore = useAppStore();
const sessionStore = useSessionStore();
const hidePayWalledProfilesPreference = computed(
  () =>
    sessionStore.isHidePayWalledProfilesPreference &&
    searchQuery.value.hidePayWalledProfiles === true
);

const updateLastSearch = (...payloads: SearchQueryUpdatePayload[]): void => {
  for (const payload of payloads) {
    LogService.info(
      `SearchResults.updateLastSearch: payload: '${payload.field}', value: '${payload.value}'`
    );
    searchStore.setLastSearchQueryField(payload);
  }
  SearchService.search(router, true);
};

const exportUniversalSearch = () => {
  const link = document.createElement("a");
  link.href =
    appStore.baseUrlOrigin +
    VignetteEndpoints.API_SEARCH_VIGNETTE_EXPORT +
    window.location.search;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
onBeforeMount(async () => {
  await ApiService.refreshBriefcase();
});

return { __sfc: true,router, isMassAddDialogOpen, searchStore, searchItems, isLoading, isPaginated, currentPage, pageSize, pageCount, hitCount, order, isListViewMode, searchQuery, appStore, sessionStore, hidePayWalledProfilesPreference, updateLastSearch, exportUniversalSearch, BriefcaseMassAddDialog, NjBtn, ExportButton, ProfileCard, ProfileListItem, SearchChipsContainer, ProfileView, SearchOrder }
}

})